import { render, staticRenderFns } from "./Subtitulo.vue?vue&type=template&id=7d7c494d&"
import script from "./Subtitulo.vue?vue&type=script&lang=js&"
export * from "./Subtitulo.vue?vue&type=script&lang=js&"
import style0 from "./Subtitulo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports